<template>
  <div class="his-search">
    <ul>
      <li class="tag-name">
        {{ $t("search.hotTags") }}
      </li>
      <li class="sec-tab">
        <span to="/searchIndex/mainSearch/resources" @click="intoDetail(0)">{{
          $t("search.studyResources")
        }}</span>
        <span to="/searchIndex/mainSearch/project" @click="intoDetail(1)">{{
          $t("search.program")
        }}</span>
        <span to="/searchIndex/mainSearch/plan" @click="intoDetail(2)">{{
          $t("search.trainPlan")
        }}</span>
        <span to="/searchIndex/mainSearch/knowledges" @click="intoDetail(3)">{{
          $t("search.contentCenter")
        }}</span>
        <span to="/searchIndex/mainSearch/elective" @click="intoDetail(4)">{{
          $t("search.courseCenter")
        }}</span>
      </li>
      <li class="tag-name for-margin">
        {{ $t("search.searchHis") }}
      </li>
      <li class="sec-his">
        <p
          v-for="(item, index) in secHistory"
          :key="index"
          @click="hisSearch(item.keyword)"
        >
          {{ item.keyword }}
        </p>
      </li>
      <li class="sec-clear" @click="clearHistory">
        <i></i>{{ $t("search.clearHis") }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "defaultView",
  data() {
    return {
      secHistory: "",
      keyword: "",
      msg: "",
    };
  },
  mounted() {
    this.getSearchHis();
  },
  methods: {
    getSearchHis() {
      let _this = this;
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        client_version: "1.2.0",
      };
      let url = "index.php/mobile/search/history-list";
      this.$axios.post(url, params).then(function (res) {
        _this.secHistory = res.data.result.list;
      });
    },
    clearHistory() {
      let _this = this;
      let url = "index.php/mobile/search/del-history";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code === 0) {
          _this.secHistory = "";
        }
      });
    },
    intoDetail(type) {
      this.$store.commit("changeNav", type);
      switch (type) {
        case 0:
          this.$router.push({ path: "/searchIndex/mainSearch/resources" });
          break;
        case 1:
          this.$router.push({ path: "/searchIndex/mainSearch/project" });
          break;
        case 2:
          this.$router.push({ path: "/searchIndex/mainSearch/plan" });
          break;
        case 3:
          this.$router.push({ path: "/searchIndex/mainSearch/knowledges" });
          break;
        case 4:
          this.$router.push({ path: "/searchIndex/mainSearch/elective" });
          break;
      }
    },
    hisSearch(keyword) {
      this.$store.commit("changeWord", keyword);
      this.$router.push({ path: "/searchIndex/mainSearch/resources" });
    },
  },
};
</script>

<style lang="less" scoped>
.his-search {
  font-size: 0.28rem;
  background: #fff;
  ul {
    li {
      padding: 0 0.2rem;
      line-height: 0.7rem;
      padding: 0 0.28rem;
      &.sec-clear {
        text-align: center;
        line-height: 0.8rem;
        color: #999999;
        font-size: 0.24rem;
        border: none;
        i {
          display: inline-block;
          width: 0.32rem;
          height: 0.32rem;
          background: url("../../assets/img/del_icon.png") no-repeat
            center/contain;
          margin-right: 0.1rem;
          vertical-align: text-bottom;
        }
      }
      &.sec-tab {
        color: #828080;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border: none;
        padding-bottom: 0.15rem;
        overflow: hidden;
        span {
          display: block;
          padding: 0 0.2rem;
          height: 0.6rem;
          line-height: 0.6rem;
          text-align: center;
          border: 1px solid #005587;
          border-radius: 0.3rem;
          color: #005587;
          margin: 0.1rem 0.2rem 0.1rem 0;
        }
      }
      &.tag-name {
        // font-size:0.2rem;
        font-size: 14px;
        line-height: 0.8rem;
        color: #666666;
        &.for-margin {
          border-top: 0.2rem solid #f5f5f5;
          border-bottom: 1px solid rgba(230, 230, 230, 0.8);
        }
      }
      &.sec-his {
        border: none;
        p {
          padding: 0 0.22rem;
          width: 6.96rem;
          margin: 0 auto;
          border-bottom: 1px solid rgba(230, 230, 230, 0.8);
          box-sizing: border-box;
          line-height: 0.8rem;
          color: #333333;
        }
      }
    }
  }
}
</style>
